import { INGAME_CAMPAIGN_TABS } from '@repo/common';
import { useAppStore, setIsIngameCampaignOnlyOpened } from 'store/app/appStore';
import { SECTION_TO_CAMPAIGN_TYPE } from 'features/campaigns';

/**
 * Hook for handling tab navigation between campaign-only layouts
 * Used by the CampaignOnlyLayouts (tournaments, prize pop, rebate, etc.)
 *
 * @returns A function that handles tab changes and switches between campaign types
 */
export const useCampaignTabNavigation = () => {
  const updateSettings = useAppStore((state) => state.updateSettings);

  const handleTabChange = (tabName: keyof typeof INGAME_CAMPAIGN_TABS) => {
    // Reset the flag to trigger campaign selection and carousel scroll in the new tab
    setIsIngameCampaignOnlyOpened(false);

    const campaignType = SECTION_TO_CAMPAIGN_TYPE[INGAME_CAMPAIGN_TABS[tabName]];
    if (campaignType) {
      updateSettings({ campaignOnly: { type: campaignType } });
    }
  };

  return handleTabChange;
};